export class DestinationTrackers {
  /**
   * Destination Overview Tracking
   * */
  static readonly DESTINATION_TRACKER_OVERVIEW_TAB_CHANGE =
    '[Destination Overview] overview tab change';

  /**
   * Add Destination Tracking
   * */
  static readonly DESTINATION_TRACKER_CREATED_NEW_DESTINATION =
    '[Add Destination] created new destination';

  static readonly DESTINATION_TRACKER_ADD_DESTINATION_WIZARD_BACK_CLICK =
    '[Add Destination] add destination wizard back click';

  static readonly DESTINATION_TRACKER_ADD_DESTINATION_WIZARD_CANCEL_CLICK =
    '[Add Destination] add destination wizard cancel click';

  static readonly DESTINATION_TRACKER_ADD_DESTINATION_WIZARD_STEP_CLICK =
    '[Add Destination] add destination wizard step click';

  static readonly DESTINATION_TRACKER_ADD_DESTINATION_DESTINATION_TYPE_SELECT =
    '[Add Destination] add destination select destination type';

  /**
   * Destination List Tracking
   * */
  static readonly DESTINATION_TRACKER_DESTINATION_LIST_REFRESH_CLICK =
    '[Destination List] refresh click';

  static readonly DESTINATION_TRACKER_DESTINATION_LIST_ADD_DESTINATION_CLICK =
    '[Destination List] add destination click';

  static readonly DESTINATION_TRACKER_DESTINATION_LIST_DESTINATION_CLICK =
    '[Destination List] destination click';

  static readonly DESTINATION_TRACKER_EMPTY_DESTINATIONS_CREATE_FIRST_DESTINATION_CLICK =
    '[Destination List] create first destination';
}
